import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-semi-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["LotAssignmentModal"], {
    isOpen: $props.isOpen,
    onClose: $setup.close,
    onConfirm: $setup.confirm
  }, {
    title: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("span", { class: "text-semi-bold" }, "Confirm Action", -1)
    ]))]),
    description: _withCtx(() => [
      _cache[1] || (_cache[1] = _createTextVNode("Are you sure you want to decline this request for", -1)),
      _createElementVNode("span", _hoisted_1, " Lot " + _toDisplayString($props.lotTitle) + "?", 1)
    ]),
    _: 1
  }, 8, ["isOpen"]))
}